import { Segment, Transition } from "semantic-ui-react";

import Flex from "../../../../components/Flex/Flex";

import themeColors from "../../constants/themeColors";

function ToastContent({ children, className, position = "center", style }) {
	return (
		<div
			style={{
				position: "fixed",
				right: position === "right" && 100,
				left: position === "center" && "50%",
				bottom: 20,
				zIndex: 1000,
				transform: position === "center" && "translateX(-50%)",
			}}
		>
			<Segment
				className={className}
				style={{
					...style,
					border: `3px solid ${themeColors.BLUE_FADED}`,
					boxShadow: "0 18px 45px -15px rgba(0, 0, 0, 0.4)",
					minWidth: 200,
				}}
			>
				<Flex justifyContent="center" gap={12}>
					{children}
				</Flex>
			</Segment>
		</div>
	);
}

export default function Toast({ open, children, position, style }) {
	return (
		<Transition.Group duration={300} animation="fade up">
			{open && (
				<ToastContent style={style} position={position}>
					{children}
				</ToastContent>
			)}
		</Transition.Group>
	);
}
